import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ageValidator(
    minAge: number = 18,
    maxAge: number = 120
): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value: string = control.value;

        if (!value) {
            return null;
        }
        if (!/^\d{8}$/.test(value)) {
            return { invalidDate: true };
        }

        const day = parseInt(value.substring(0, 2), 10);
        const month = parseInt(value.substring(2, 4), 10) - 1;
        const year = parseInt(value.substring(4, 8), 10);

        const birthDate = new Date(year, month, day);

        if (
            isNaN(birthDate.getTime()) ||
            birthDate.getDate() !== day ||
            birthDate.getMonth() !== month ||
            birthDate.getFullYear() !== year
        ) {
            return { invalidDate: true };
        }

        const today = new Date();
        const minDate = new Date(today.getFullYear() - minAge, today.getMonth(), today.getDate());
        const maxDate = new Date(today.getFullYear() - maxAge, today.getMonth(), today.getDate());

        if (birthDate > minDate) {
            return { underAge: true };
        }

        if (birthDate < maxDate) {
            return { overAge: true };
        }

        return null;
    };
}